import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listGenerationSites } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  ListGenerationSitesRequestSchema,
  type ListGenerationSitesResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/** 発電所 (サイト) の一覧取得 hook。絞り込み・並びは画面側 (`models/siteRows.ts`) で行う。 */
export function useListGenerationSites(): UseQueryResult<
  ListGenerationSitesResponse,
  ConnectError
> {
  return useQuery(
    listGenerationSites,
    create(ListGenerationSitesRequestSchema, {}),
  )
}
